import React from "react";
import _ from "lodash";
import { Map } from "immutable";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Action } from "typescript-fsa";

import { makeChartsIndex } from "@api/index";
import { connectToApi, ApiConnectedProps } from "@api/components/connectToApi";
import { AuthState } from "@auth/models";
import { MusicState } from "@music/models";
import { FilesState } from "@files/models";
import { SalesState } from "@sales/models";
import { getSettingType, getSettingFrom, getSettingTo } from "@sales/selectors";
import { compose } from "@util/compose";
import { getChartType } from "../../models";
import { getChartsHydrated, getChartsLastLoaded } from "../../selectors";
import { ChartList } from "../ChartList";
import {
    Chart as Model,
    ChartsState,
} from "../../models";

interface ChartProps {
    chart: Model;
    downloadAction: () => Action<any>;
    message: {
        id: string;
        defaultMessage: string;
    };
}

interface ChartsStateProps extends ApiConnectedProps {
    charts: Map<string, Model>;
    downloadAction: (name: string) => () => Action<any>;
    lastLoaded: Date[];
    type: "stream" | "download";
}

type ChartsProps = ChartsStateProps;
type State = ChartsState & MusicState & FilesState & AuthState & SalesState;

const Chart = ({chart, message, downloadAction}: ChartProps) => (
    <div className="charts__chart">
        <h3 className="display-2">
            <FormattedMessage {...message} />
        </h3>
        <ChartList chart={chart} downloadAction={downloadAction}></ChartList>
    </div>
);

const Charts = ({ charts, downloadAction, type }: ChartsProps) => {
    // Add the charts.
    const els: JSX.Element[] = charts.map((chart, key) => (
        type === getChartType(key) && <Chart
            key={key}
            chart={chart}
            downloadAction={downloadAction(chart.name)}
            message={{id: "charts.chart." + key, defaultMessage: key}}
        />
    )).toArray();

    return (
        <div className="charts">
            { els }
        </div>
    );
};

const ConnectedCharts = compose<ChartsProps, {}>(
    connect((state: State, _props: ChartsProps) => {
        const from = getSettingFrom(state);
        const to = getSettingTo(state);
        return {
            actionCreators: [makeChartsIndex(from, to)],
            downloadAction: (name: string) => makeChartsIndex(from, to, true, name),
            requestId: [from.format() + "_" + to.format()],
            charts: getChartsHydrated(state),
            lastLoaded: [getChartsLastLoaded(state)],
            type: getSettingType(state),
        } as ChartsStateProps;
    }, null),
    connectToApi({}),
)(Charts);

export {
    Charts as ChartsPresenter,
    Chart as ChartPresenter,
    ConnectedCharts as Charts,
    ChartsProps,
};
